const _range = require('lodash/range');
const _forEach = require('lodash/forEach');

const teenaagerIntermediaryUrls = function (chartType, gender) {
  const age_array = _range(15, 20); // 15 to 19 inclusive
  const adult_urls = {};

  _forEach(age_array, function (age) {
    adult_urls[age + ' years old'] = '/' + chartType + '/' + gender + '/' + age + '-years-old';
  });

  return adult_urls;
};
const youngAdultIntermediaryUrls = function (chartType, gender) {
  const age_array = _range(20, 25); // 20 to 24 inclusive
  const adult_urls = {};

  _forEach(age_array, function (age) {
    adult_urls[age + ' years old'] = '/' + chartType + '/' + gender + '/' + age + '-years-old';
  });

  return adult_urls;
};
const youngProfessionalIntermediaryUrls = function (chartType, gender) {
  const age_array = _range(25, 35); // 20 to 34 inclusive
  const adult_urls = {};

  _forEach(age_array, function (age) {
    adult_urls[age + ' years old'] = '/' + chartType + '/' + gender + '/' + age + '-years-old';
  });

  return adult_urls;
};
const professionalAdultIntermediaryUrls = function (chartType, gender) {
  const age_array = _range(35, 45); // 35 to 44 inclusive
  const adult_urls = {};

  _forEach(age_array, function (age) {
    adult_urls[age + ' years old'] = '/' + chartType + '/' + gender + '/' + age + '-years-old';
  });

  return adult_urls;
};
const middleAgedAdultIntermediaryUrls = function (chartType, gender) {
  const age_array = _range(45, 55); // 45 to 54 inclusive
  const adult_urls = {};

  _forEach(age_array, function (age) {
    adult_urls[age + ' years old'] = '/' + chartType + '/' + gender + '/' + age + '-years-old';
  });

  return adult_urls;
};
const lateMiddleAgedAdultIntermediaryUrls = function (chartType, gender) {
  const age_array = _range(55, 65); // 45 to 54 inclusive
  const adult_urls = {};

  _forEach(age_array, function (age) {
    adult_urls[age + ' years old'] = '/' + chartType + '/' + gender + '/' + age + '-years-old';
  });

  return adult_urls;
};
const retireesIntermediaryUrls = function (chartType, gender) {
  const age_array = _range(65, 75); // 45 to 54 inclusive
  const adult_urls = {};

  _forEach(age_array, function (age) {
    adult_urls[age + ' years old'] = '/' + chartType + '/' + gender + '/' + age + '-years-old';
  });

  return adult_urls;
};
const seniorsIntermediaryUrls = function (chartType, gender) {
  const age_array = _range(75, 101); // 45 to 54 inclusive
  const adult_urls = {};

  _forEach(age_array, function (age) {
    adult_urls[age + ' years old'] = '/' + chartType + '/' + gender + '/' + age + '-years-old';
  });

  return adult_urls;
};
module.exports = {
  // babyIntermediaryUrls: babyIntermediaryUrls,
  // toddlerIntermediaryUrls: toddlerIntermediaryUrls,
  // preSchoolerIntermediaryUrls: preSchoolerIntermediaryUrls,
  // childIntermediaryUrls: childIntermediaryUrls,
  teenaagerIntermediaryUrls: teenaagerIntermediaryUrls,
  youngAdultIntermediaryUrls: youngAdultIntermediaryUrls,
  youngProfessionalIntermediaryUrls: youngProfessionalIntermediaryUrls,
  professionalAdultIntermediaryUrls: professionalAdultIntermediaryUrls,
  middleAgedAdultIntermediaryUrls: middleAgedAdultIntermediaryUrls,
  lateMiddleAgedAdultIntermediaryUrls: lateMiddleAgedAdultIntermediaryUrls,
  retireesIntermediaryUrls: retireesIntermediaryUrls,
  seniorsIntermediaryUrls: seniorsIntermediaryUrls,
};
